import React, {PureComponent} from "react";
import {PropTypes} from "prop-types";

class Loading extends PureComponent {

	_getColor = () => {
		switch (this.props.color) {
			case "black":
				return "text-dark";
			case "white":
				return "text-light";
			case "red":
				return "text-danger";
			case "yellow":
				return "text-warning";
			case "green":
				return "text-success";
			default:
				return "text-primary";

		}
	};

	render() {

		const color = this._getColor();

		return (
			<div className={"spinner-border " + this.props.size + " " + color + " " + this.props.className}
			     role="status">
				<span className="sr-only">Loading...</span>
			</div>
		)
	}

}

Loading.propTypes = {
	size: PropTypes.oneOf([
		"small-spinner",
		"medium-spinner",
		"large-spinner",
		"extra-large-spinner"
	]),
	color: PropTypes.oneOf([
		"blue",
		"red",
		"green",
		"yellow",
		'white',
		'black',
	]),
	className: PropTypes.string,
};

Loading.defaultProps = {
	size: "medium-spinner",
	color: "blue",
	className: "",
};

export default Loading;